<template>
    <div id="setup-tab-evo-container">
        <b-row>
            <b-col md="12" lg="12" sm="12">
                <MdMemo
                    v-bind:Label="$t('Login.cId')"
                    v-bind:Name="'client_id'"
                    v-bind:Rows="'5'"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'120'"
                    v-bind:VisibleLabel="true"
                    v-model="editableItem.clientId"
                    v-on:change="emitChanged"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col md="12" lg="12" sm="12">
                <MdMemo
                    v-bind:Label="$t('PPDbSetup.ClientSecret')"
                    v-bind:Name="'client_id'"
                    v-bind:Rows="'5'"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'120'"
                    v-bind:VisibleLabel="true"
                    v-model="editableItem.clientSecret"
                    v-on:change="emitChanged"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'TabSetupEvo',
    props: {
        value: {
            Type: Object,
            default: null
        },
        isReadOnly: {
            Type: Boolean,
            default: false
        }
    },
    data() {
        const defaultItemData = {
            clientId: '',
            clientSecret: ''
        };
        return {
            editableItem: this.value || defaultItemData,
            defaultItemData: defaultItemData
        };
    },
    watch: {
        value(newVal) {
            this.editableItem = newVal || this.defaultItemData;
        },
        'editableItem.clientId'() {
            this.emitChanged();
        },
        'editableItem.clientSecret'() {
            this.emitChanged();
        }
    },
    methods: {
        emitChanged() {
            this.$emit('input', this.editableItem);
        }
    }
};
</script>
